var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 3V7.75",
    stroke: "#AB1010",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11 3.38751C11.9937 4.03423 12.7519 4.98475 13.1614 6.09741C13.571 7.21006 13.61 8.42528 13.2727 9.56193C12.9355 10.6986 12.2399 11.6958 11.2897 12.405C10.3395 13.1141 9.18564 13.4973 8 13.4973C6.81436 13.4973 5.66046 13.1141 4.71029 12.405C3.76011 11.6958 3.06455 10.6986 2.72725 9.56193C2.38996 8.42528 2.429 7.21006 2.83856 6.09741C3.24812 4.98475 4.00627 4.03423 5 3.38751",
    stroke: "#AB1010",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.923505733f49281f4f700041836b7eae.svg";
export { ForwardRef as ReactComponent };